import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import SelectEmpresa from '../incidencias/incidenciasregistro/SelectEmpresa';
import SelectPeriodo from '../incidencias/incidenciasregistro/SelectPeriodo';
import { obtenerperiododispercion, obtenerlistadepta } from '../../Redux/DepartamentosDucks'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack';
import SelectDepartamento from '../incidencias/incidenciasregistro/SelectDepartamento';
import { Grid } from '@mui/material';
import ResultadoDatosDispersion from './ResultadoDatosDispersion';

const { REACT_APP_API_URL } = process.env;


const steps = ['- Empresa', '- Departamento', '- Periodo', '- Resumen '];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}

        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


export default function ContenedorPasosDispersion() {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [value, setValue] = React.useState(0);
    const [bd, setBd] = React.useState('');
    const [dep, setDep] = React.useState([]);
    const [periodo, setPeriodo] = React.useState('');
    const [periodo2, setPeriodo2] = React.useState('');
    const [lineacaptura, setLineaCaptura] = React.useState([]);
    const [totales, SetTotales] = React.useState();

    const [datadispersion, SetDataDispersion] = React.useState([])


    const fechainicial = new Date(periodo.fechainicio)
    fechainicial.setDate(fechainicial.getDate() + 1)

    const fechafinal = new Date(periodo.fechafin)
    fechafinal.setDate(fechafinal.getDate() + 1)


    const ejercicio = new Date().getFullYear()

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = (newValue) => {
        const dato = newValue + 1
        let newSkipped = skipped;

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped)
        setValue(dato);
    };
    const handleNext0 = (v) => {

        setActiveStep(v);
        setValue(v);

        switch (v) {
            case 1:
                dispatch(obtenerlistadepta(bd))
                break;
            case 2:
                dispatch(obtenerperiododispercion(bd, dep.iddepartamento))
                break;
            default:
                break;
        }
    };


    const handleBack = (newValue) => {
        const dato = newValue - 1
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setValue(dato);
    };
    const handleReset = () => {
        setActiveStep(0);
        setValue(0);
    };
    const obtenerBDhijo = (bd) => {
        setBd(bd)
    }
    const obtenerDeptahijo = (depta) => {
        setDep(depta)

    }
    const obtenerPeriodohijo = (p) => {
        setPeriodo(p)
    }
    const obtenerPeriodohijo2 = (e) => {
        setPeriodo2(e)
    }

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const success = resultado.success
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });

        if (success === false) {
            setActiveStep(0);
            setValue(0)

        } else {
            handleNext(2)
            SetDataDispersion(resultado.resumen)
        }
    };

    const handleClickVariant2 = (resultado) => {
        const variant = resultado.variant
        const success = resultado.success
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });

        if (success === false) {
            setActiveStep(0);
            setValue(0)

        } else {
            handleNext(2)
            SetDataDispersion(resultado.resumen)
            setLineaCaptura(resultado.lineacaptura)
            SetTotales(resultado.totales)
        }
    };
    const idperiodo2 = periodo2.idperiodo ? parseInt(periodo2.idperiodo) : 0

    const obtenerArchivoDispercion = async () => {

        const iddepartamento = dep.iddepartamento;
        const idperiodo = parseInt(periodo.idperiodo);

        const result = {
            'variant': 'error',
            'success': 'error',
            'msg': 'El campo esta vacio perido, departamento o empresa'
        }
        const result2 = {
            'variant': 'warning',
            'success': 'error',
            'msg': 'El perido no debe ser igual ó no seleccionó el 2do periodo, si es de un periodo selecciona la *casilla fin del mes'
        }
        if (idperiodo === idperiodo2 || idperiodo2 === '') {
            handleClickVariant(result2)
            setActiveStep(2);
            setValue(2)
        } else {


            if (dep === '' && bd === '') {
                handleClickVariant(result)
                setActiveStep(2);
                setValue(2)
            } else {

                const token = sessionStorage.getItem('%t')
                var myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");
                var requestOptions = {
                    method: 'GET',
                    headers: myHeaders,
                    redirect: 'follow'
                };

                try {
                    const response = await fetch(`${REACT_APP_API_URL}/archivo?guidempresa=${bd}&iddepartamento=${iddepartamento}&idperiodo1=${idperiodo}&idperiodo2=${idperiodo2}`, requestOptions,);
                    const resultado = await response.json();
                    return (handleClickVariant2(resultado))

                } catch (error) {
                    console.log("Algo salio mal", error);
                }
            }
        }
    }

    return (
        <Box sx={{ width: '100%' }}  padding='12px'>
            <Grid container justifyContent='center'>
                <Grid >
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};

                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps} >
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Grid>
            </Grid>

            <TabPanel value={value} index={0}>
                <SelectEmpresa
                    obtenerBDhijo={obtenerBDhijo}
                    obtenerDeptahijo={obtenerDeptahijo}
                    bd={bd}
                    dep={dep}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SelectDepartamento
                    obtenerBDhijo={obtenerBDhijo}
                    obtenerDeptahijo={obtenerDeptahijo}
                    bd={bd}
                    dep={dep}
                />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SelectPeriodo
                    obtenerPeriodohijo={obtenerPeriodohijo}
                    obtenerPeriodohijo2={obtenerPeriodohijo2}
                    periodo={periodo}
                    periodo2={periodo2}
                    ejercicio={ejercicio}
                    bd={bd}
                    dis={true}
                    dep={dep}
                />

            </TabPanel>
            <TabPanel value={value} index={3}>
                <ResultadoDatosDispersion
                    data={datadispersion}
                    lineacaptura={lineacaptura}
                    totales={totales}
                    handleBack={handleBack}
                />
            </TabPanel>
            {activeStep === steps.length ? (
                <>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        Haz finalizado
                    </Typography>
                </>
            ) : (
                <>

                    <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center', flexDirection: 'row', pt: 3, width: '100%' }}>
                        {activeStep === 3 ? (<>


                        </>) : <Button
                            variant='contained' color='success'
                            disabled={activeStep === 0 || activeStep === 4}
                            onClick={() => handleBack(value)}
                            sx={{ mr: 28 }}
                        >
                            Atras
                        </Button>}

                        <Box />

                        {activeStep === 2 ? (
                            <>
                                <Button
                                    onClick={() => obtenerArchivoDispercion()} variant='contained' color='success'>
                                    Siguiente
                                </Button>
                            </>
                        ) : null
                        }

                        {activeStep === 0 ? (
                            <>
                                <Button
                                    onClick={() => handleNext0(1)} variant='contained' color='success'>
                                    Siguiente
                                </Button>
                            </>
                        ) : null
                        }

                        {activeStep === 1 ? (
                            <>
                                <Button
                                    onClick={() => handleNext0(2)} variant='contained' color='success'>
                                    Siguiente
                                </Button>
                            </>
                        ) : null
                        }
                    </Box>
                </>
            )}
        </Box>
    );
}